/*
 * Author: Dw
 * File Created: Monday, 24-08-05 11:06 am
 * Last Modified: Friday, 24-12-06 04:09 pm, by Harper Yan
 */

import Head from 'next/head';
import type { StackProps } from '@mui/material';
import { Box, Stack } from '@mui/material';
import Footer from './Footer';
import Header from './Header';
interface LandingContainerProps extends StackProps {
  vip?: boolean;
  meta?: {
    title: string;
    description?: string;
  };
}
const LandingContainer = ({
  vip = false,
  children,
  meta,
  ...props
}: LandingContainerProps) => {
  return <Stack minHeight="100vh" {...props} data-sentry-element="Stack" data-sentry-component="LandingContainer" data-sentry-source-file="index.tsx">
      {meta && <Head>
          <title>{meta.title}</title>
          {meta.description && <meta content={meta.description} name="description" />}
        </Head>}
      <Header vip={vip} data-sentry-element="Header" data-sentry-source-file="index.tsx" />
      <Box component="main" flex={1} width="100%" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {children}
      </Box>
      <Footer vip={vip} data-sentry-element="Footer" data-sentry-source-file="index.tsx" />
    </Stack>;
};
export default LandingContainer;